export const COLOR_PRIMARY = "#F0B27A";
export const COLOR_SECONDARY = "#185F8F";
export const COLOR_ERROR = "#D85040";
export const COLOR_WHITE = "#FFFFFF";
export const COLOR_GRAY = "#D6D6D6";
export const COLOR_BLACK = "#202030";

export const COLOR_GREEN = "#61bb48";
export const COLOR_RED = "#c85948";
